import { render, staticRenderFns } from "./pointage-scrollalphabet.vue?vue&type=template&id=5f5d893b&scoped=true&"
import script from "./pointage-scrollalphabet.vue?vue&type=script&lang=ts&"
export * from "./pointage-scrollalphabet.vue?vue&type=script&lang=ts&"
import style0 from "./pointage-scrollalphabet.vue?vue&type=style&index=0&id=5f5d893b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5d893b",
  null
  
)

export default component.exports